import React from "react"
import { Link } from "gatsby"
import { Container, Row, Col, Nav, Button } from "react-bootstrap"
import Text from "@src/utils/text"

import EmailSignUp from "@components/EmailSignUp"

const Footer = () => {
  return (
    <footer id="footer">
      <section className="py-5 py-md-6 bg-dark">
        <Container>
          <Row className="text-white text-center">
            <Col>
              <Text id="ngI4ni99MMGWd8hHrgBZQ" />
              {/* <IoIosFlower className="text-powder" size="3em" /> */}
              <a
                href="https://yoursessionwithfifi.setmore.com/"
                target="_newTab"
              >
                <Button variant="outline-lipstick" size="lg">
                  Book a consultation!
                </Button>
              </a>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="bg-lipstick py-5">
        <Container>
          <Row className="justify-content-between">
            <Col md={7} className="mb-3 mb-md-0">
              <Text id="34FnLAKdSjXh8bHFAEhCHv" />
              <EmailSignUp />
            </Col>
            <Col md={3}>
              <h4>Navigation:</h4>
              <Nav defaultActiveKey="/home" className="flex-column footer-nav">
                <Nav.Link href="/home">Home</Nav.Link>
                <Nav.Link as={Link} to="/" eventKey="link-1">
                  About
                </Nav.Link>
                <Nav.Link as={Link} to="/about" eventKey="link-2">
                  Courses
                </Nav.Link>
                <Nav.Link as={Link} to="/courses" eventKey="link-2">
                  Appointment
                </Nav.Link>
                <Nav.Link as={Link} to="/products" eventKey="link-2">
                  Contact
                </Nav.Link>
              </Nav>
            </Col>
          </Row>
        </Container>
      </section>

      <Nav
        className="justify-content-center align-items-center bg-powder trademark text-lipstick"
        activeKey="/home"
      >
        <span className="mr-2">
          Copyright Coach Fifi ® {new Date().getFullYear()}
        </span>
        <Nav.Item>
          <Nav.Link eventKey="link-1">GDRP</Nav.Link>
        </Nav.Item>
        |
        <Nav.Item>
          <Nav.Link eventKey="link-2">Cookies</Nav.Link>
        </Nav.Item>
      </Nav>
    </footer>
  )
}

export default Footer
